import { render, staticRenderFns } from "./ViewSimpleImageField.vue?vue&type=template&id=67946c14&"
import script from "./ViewSimpleImageField.vue?vue&type=script&lang=js&"
export * from "./ViewSimpleImageField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports